module.exports = __webpack_public_path__ + "img/10.8a4cb8d7.png";